<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="name" width="6">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="name-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Asc"
               sortField="extension.name"
            >
               Name <mat-icon class="mat-icon-sort">{{ getSort('extension.name') }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ presenceContact.displayName != '' ? presenceContact.displayName : presenceContact.extension.name }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ presenceContact.displayName != '' ? presenceContact.displayName : presenceContact.extension.name }}
               </span>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="number" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="number-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="extension.number"
            >
               Extension Number <mat-icon class="mat-icon-sort">{{ getSort('extension.number') }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ presenceContact.extension.number }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ presenceContact.extension.number }}
               </span>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="onCall" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="onCall-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="Notset"
               sortField="onCall"
            >
               On/Off Call <mat-icon class="mat-icon-sort">{{ getSort('onCall') }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ presenceContact.onCall ? 'On Call' : 'Off Call' }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ presenceContact.onCall ? 'On Call' : 'Off Call' }}
               </span>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="dndStatus" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="dndStatus-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="dndStatus"
            >
               DND Status <mat-icon class="mat-icon-sort">{{ getSort('dndStatus') }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ presenceContact.dndStatus }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ presenceContact.dndStatus }}
               </span>
               }
            </td>
         </ng-container>

         <ng-container lcsColumnDef="office" width="6">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="availability-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="office"
            >
               Office <mat-icon class="mat-icon-sort">{{ getSort('office') }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ presenceContact.office }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ presenceContact.office }}
               </span>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="departments" width="3">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="availability-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               sortDirection="NotSet"
               sortField="extension.departmentExtensions.department.name"
            >
               Departments<mat-icon class="mat-icon-sort">{{
                  getSort('extension.departmentExtensions.department.name')
               }}</mat-icon>
            </th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button class="table-button" type="button" (click)="onRowClick(presenceContact)">
                  {{ commaSeperatedDepartmentNames(presenceContact.departmentExtensions) }}
               </button>
               } @if (!hasEditingRegisterPrivileges) {
               <span>
                  {{ commaSeperatedDepartmentNames(presenceContact.departmentExtensions) }}
               </span>
               }
            </td>
         </ng-container>
         <ng-container lcsColumnDef="optionsMenu" width="2">
            <th lcs-header-cell *lcsHeaderCellDef id="devices-actions-menu-column-header"></th>
            <td
               lcs-cell
               *lcsCellDef="let presenceContact"
               [ngClass]="{ dnd: presenceContact.dndStatus, onCall: presenceContact.onCall }"
            >
               @if (hasEditingRegisterPrivileges) {
               <button
                  type="button"
                  aria-label="Presence Contact Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="presenceMenu"
                  [matMenuTriggerData]="{ $implicit: presenceContact, index: presenceContactIndex }"
                  id="presence-contact-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               }
               <mat-menu #presenceMenu="matMenu">
                  @if (hasEditingRegisterPrivileges) {
                  <button type="button" mat-menu-item (click)="onRowClick(presenceContact)">
                     Edit Presence Contact
                  </button>
                  } @if ( currentUser.extension?.number && currentUser.userAccount?.name && !presenceContact.dndStatus
                  && !presenceContact.onCall && presenceContact.extension.number !== currentUser.extension?.number ) {
                  <button
                     type="button"
                     mat-menu-item
                     [disabled]="isCallDisabledForAnyContact"
                     (click)="onInitiateDirectedCall(presenceContact)"
                  >
                     Call contact
                  </button>
                  }
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
